import React, { useState } from "react";
import { Text, Group } from "@mantine/core";

import Coupons from "./Coupons";
import Bundles from "./Bundles";
import TaxCollection from "./TaxCollection";

import { Accordion } from "@mantine/core";

export default function Extras(props) {
  const [accordionState, setAccordionState] = useState({
    0: false,
    1: false,
    2: false
  });

  const AccordionLabel = ({ label, description, index }) => {
    return (
      <Group noWrap>
        <div>
          <Text size="lg" weight={700}>
            {label}
          </Text>

          {!accordionState[index] ? (
            <Text size="sm" color="dimmed" weight={400}>
              {description} {index == 2 && (
                <Text color="#41c3f6" underline component="a" onClick={openTax}>Stripe Tax</Text>
              )}
            </Text>
          ) : (
            ""
          )}
        </div>
      </Group>
    );
  };

  const openTax = () => {
    window.open("https://docs.stripe.com/tax", "_blank");
  };

  return (
    <Accordion>
      <Accordion.Item
        label={
          <AccordionLabel
            index={0}
            label={"Coupons"}
            key={"coupons"}
            description={`Coupons allow you to offer custom discounts on space payments.`}
          />
        }
      >
        <Coupons />
      </Accordion.Item>

      <Accordion.Item
        label={
          <AccordionLabel
            index={1}
            label={"Bundles"}
            key={"bundles"}
            description={`Bundles allow you to package access to multiple spaces with one purchase.  You can have them show up on your checkout page or add a bundle button from the block menu on any content page.`}
          />
        }
      >
        <Bundles />
      </Accordion.Item>

      <Accordion.Item
        label={
          <AccordionLabel
            index={2}
            label={"Tax collection"}
            key={"tax_collection"}
            description={"Sutra can automatically process taxes on payments you collect if you have set up"}
          />
        }
      >
        <TaxCollection />
      </Accordion.Item>
    </Accordion>
  );
}
